/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preferences_Theme_DescriptionInputs */



/**
* | output |
* | --- |
* | "Customize the appearance of the application" |
*
* @param {Preferences_Theme_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const preferences_theme_description = /** @type {((inputs?: Preferences_Theme_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preferences_Theme_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Passe das Erscheinungsbild der Anwendung an")
	return /** @type {LocalizedString} */ ("Customize the appearance of the application")
});